import type { enShop } from './en-shop';

/** Turkish strings — shop simplification (docs/03 W4). */
export const trShop: Record<keyof typeof enShop, string> = {
  'cardrarity.common': 'SIRADAN',
  'cardrarity.uncommon': 'SEYREK',
  'cardrarity.rare': 'NADİR',
  'cardrarity.epic': 'EPİK',
  'cardrarity.legendary': 'EFSANEVİ',
  'cardrarity.mythic': 'MİTİK',

  'statp.group.offense': 'SALDIRI',
  'statp.group.defense': 'SAVUNMA',
  'statp.group.mobility': 'HAREKET',
  'statp.group.economy': 'EKONOMİ',
  'statp.base': 'Standart gemi — henüz yükseltme yok',
} as const;
